import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Chantilly Cannabis News</p>
        <h1>Your Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis laws, policies, and cultural insights in the Chantilly area. Our mission is to provide comprehensive coverage and educational resources to empower our community.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Keep up with the evolving landscape of cannabis legislation in Chantilly. Our coverage includes recent changes, proposed bills, and community discussions.
          </p>
        </article>
        <article>
          <h2>Understanding Cannabis Policy</h2>
          <p>
            Dive into the complexities of cannabis policy. We provide clear explanations and insights to help you navigate the legal framework surrounding cannabis use and cultivation.
          </p>
        </article>
        <article>
          <h2>Cultural Insights</h2>
          <p>
            Discover the cultural aspects of cannabis in our community. From events to local stories, we highlight the diverse perspectives and experiences that shape the cannabis culture in Chantilly.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;